import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-title',
  templateUrl: './title.component.html',
  styleUrls: ['./title.component.scss'],
})
export class TitleComponent  implements OnInit {

  @Input() titleText: string = '';

  @Output() inputChange = new EventEmitter<{
    titleText: string;
  }>();
  constructor() {}

  ngOnInit() {
    const formattedActualite = JSON.parse(localStorage.getItem('formattedActualite') || '{}');
    if (!formattedActualite.articleBlocks) {
      return;
    }
    const block = formattedActualite.articleBlocks.find((block: any) => block.type === 3);
    if (block) {
      this.titleText = block.content.titleText;
      this.onInputChange();
    }
  }

  onInputChange() {
    this.inputChange.emit({
      titleText: this.titleText,
    });
  }
}
